import React, { ComponentProps } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { Text } from 'components/Text'
import {
  BenefitsRoot,
  BenefitsSection,
  TextWrapper,
  ImageWrapper,
  IconWrapper,
  BenefitsContainer,
  SectionTitle,
  Blob1Wrapper,
  Blob2Wrapper,
  Blob3Wrapper,
  Blob4Wrapper,
} from './Benefits.styles'
import Image from 'next/image'
import Badge from '../../../../../public/assets/recipes/categories/meet-our-meats-badge.png'
import Packaging from '../../../../../public/assets/recipes/categories/meat-packaging.png'
import Box from '../../../../../public/assets/recipes/categories/we-feed-raw-box.png'
import Prepping from '../../../../../public/assets/recipes/categories/preparing-meal.png'
import Happy from '../../../../../public/assets/recipes/categories/happy-owner-and-dog.png'
import Meat from '../../../../../public/assets/recipes/categories/ribeye.png'
import SmileyDog from '../../../../../public/assets/recipes/categories/smiley-dog.png'
import Heart from '../../../../../public/assets/recipes/categories/wfr-heart.png'
import Trans from 'next-translate/Trans'
import Blob1 from '../../../../../public/assets/recipes/categories/blob1.png'
import Blob2 from '../../../../../public/assets/recipes/categories/blob2.png'
import Blob3 from '../../../../../public/assets/recipes/categories/blob3.png'
import Blob4 from '../../../../../public/assets/recipes/categories/blob4.png'

type BenefitsOwnProps = ComponentProps<typeof BenefitsRoot>
export type BenefitsProps = BenefitsOwnProps & {}

export const Benefits = (_props: BenefitsProps) => {
  const { t } = useTranslation()

  return (
    <BenefitsRoot id="recipes-2">
      <BenefitsContainer>
        <SectionTitle>
          <Text
            size="h1"
            as="h2"
            color="primary-500"
            weight="semiBold"
            display={{ '@initial': 'none', '@bp2': 'block' }}
          >
            <Trans components={{ br: <br /> }} i18nKey={'recipes:overview.benefits.title'} />
          </Text>
          <Text
            css={{lineHeight: '$h2'}}
            as="h2"
            color="primary-500"
            size="h2"
            weight="semiBold"
            display={{ '@initial': 'block', '@bp2': 'none' }}
          >
            <Trans components={{ br: <br /> }} i18nKey={'recipes:overview.benefits.title-m'} />
          </Text>
        </SectionTitle>

        <BenefitsSection>
          <TextWrapper type="safety">
            <Text
              align={{ '@initial': 'center', '@bp2': 'left' }}
              size='h4'
              weight="semiBold"
              color="primary-500"
            >
              {t('recipes:overview.benefits.safety.subtitle')}
            </Text>
            <Text color="accent-black" align={{ '@initial': 'center', '@bp2': 'left' }} size={{'@initial': 'headline', '@bp2': 'h5'}}>
              <Trans
                i18nKey="recipes:overview.benefits.safety.description"
                components={{ strong: <strong /> }}
              />
            </Text>
          </TextWrapper>
          <ImageWrapper zIndex="2">
            <Image src={Packaging} alt={t('recipes:overview.benefits.safety.img')} />
          </ImageWrapper>
          <IconWrapper type="badge">
            <Image src={Badge} alt={t('recipes:overview.benefits.badge')} />
          </IconWrapper>
        </BenefitsSection>
        <BenefitsSection>
          <ImageWrapper zIndex="3">
            <Image src={Box} alt={t('recipes:overview.benefits.convenience.img')} />
          </ImageWrapper>
          <TextWrapper type="convenience">
            <Text
              align={{ '@initial': 'center', '@bp2': 'left' }}
              size='h4'
              weight="semiBold"
              color="primary-500"
            >
              {t('recipes:overview.benefits.convenience.subtitle')}
            </Text>
            <Text color="accent-black" align={{ '@initial': 'center', '@bp2': 'left' }} size={{'@initial': 'headline', '@bp2': 'h5'}}>
              <Trans
                i18nKey="recipes:overview.benefits.convenience.description"
                components={{ strong: <strong /> }}
              />
            </Text>
          </TextWrapper>
        </BenefitsSection>
        <BenefitsSection>
          <TextWrapper type="quality">
            <Text
              align={{ '@initial': 'center', '@bp2': 'left' }}
              size='h4'
              weight="semiBold"
              color="primary-500"
            >
              {t('recipes:overview.benefits.quality.subtitle')}
            </Text>
            <Text color="accent-black" align={{ '@initial': 'center', '@bp2': 'left' }} size={{'@initial': 'headline', '@bp2': 'h5'}}>
              <Trans
                i18nKey="recipes:overview.benefits.quality.description"
                components={{ strong: <strong /> }}
              />
            </Text>
          </TextWrapper>
          <ImageWrapper zIndex="2">
            <Image src={Prepping} alt={t('recipes:overview.benefits.quality.img')} />
          </ImageWrapper>
          <IconWrapper type="meat">
            <Image src={Meat} alt={t('recipes:overview.benefits.meat')} />
          </IconWrapper>
        </BenefitsSection>
        <BenefitsSection>
          <ImageWrapper zIndex="1">
            <Image src={Happy} alt={t('recipes:overview.benefits.results.img')} />
          </ImageWrapper>
          <TextWrapper type="result">
            <Text
              align={{ '@initial': 'center', '@bp2': 'left' }}
              size='h4'
              weight="semiBold"
              color="primary-500"
            >
              {t('recipes:overview.benefits.results.subtitle')}
            </Text>
            <Text color="accent-black" align={{ '@initial': 'center', '@bp2': 'left' }} size={{'@initial': 'headline', '@bp2': 'h5'}}>
              <Trans
                i18nKey="recipes:overview.benefits.results.description"
                components={{ strong: <strong /> }}
              />
            </Text>
          </TextWrapper>

          <IconWrapper type="heart">
            <Image src={Heart} alt={t('recipes:overview.benefits.heart')} />
          </IconWrapper>
          <IconWrapper type="dog">
            <Image src={SmileyDog} alt={t('recipes:overview.benefits.smiley-dog')} />
          </IconWrapper>
        </BenefitsSection>
      </BenefitsContainer>
      <Blob1Wrapper>
        <Image src={Blob1} alt="" />
      </Blob1Wrapper>
      <Blob2Wrapper>
        <Image src={Blob2} alt="" />
      </Blob2Wrapper>
      <Blob3Wrapper>
        <Image src={Blob3} alt="" />
      </Blob3Wrapper>
      <Blob4Wrapper>
        <Image src={Blob4} alt="" />
      </Blob4Wrapper>
    </BenefitsRoot>
  )
}

Benefits.displayName = 'Benefits'
